import React, { useState } from "react";
import PropTypes from "prop-types";
import { useField, useFormikContext } from "formik";

import "../../../styles/labelCheckbox.scss";

const LabelCheckBox = (props) => {
  const { label, value } = props;

  const [field, meta] = useField(props);

  console.log(meta?.initialValue);

  const formikContext = useFormikContext();
  const [isChecked, setIsChecked] = useState(
    meta?.initialValue?.includes(value) || false
  );

  const classNames = ["label-checkbox"];

  if (isChecked) classNames.push("label-checkbox--checked");

  const handleClick = () => {
    // * Get current value
    const currentValue = meta.value;

    if (!Array.isArray(currentValue)) {
      // TODO: Add support for normal checkbox
      return;
    }

    // * Remove value
    if (isChecked) {
      const newValues = currentValue.filter((cv) => cv !== value);
      formikContext.setFieldValue(field?.name, newValues);
      setIsChecked(false);
      return;
    }

    // * Add value
    currentValue.push(value);
    formikContext.setFieldValue(field?.name, currentValue);
    setIsChecked(true);
  };

  return (
    <div className={classNames.join(" ")} onClick={handleClick}>
      {label}
    </div>
  );
};

LabelCheckBox.propTypes = {};

export default LabelCheckBox;
